<template>
    <div class="detail-info-container">
        <div class="detail-info">
            <Provided
                v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.top"
                theme="template1"
            />
            <!-- other components between Provided top and Provided above -->
            <Provided
                v-if="positionProvided && positionProvided === PROVIDED_POSITION_KEY.above"
                theme="template1"
            />
            <DetailInfoHeader></DetailInfoHeader>
            <DetailInfoGroup
                :openReadMore="openReadMore"
                :firstRowClass="
                    info.listingStatus != 'Sold'
                        ? 'two-columns'
                        : 'three-columns'
                "
                :otherRowClass="
                    info.listingStatus != 'Sold'
                        ? 'single-column'
                        : 'two-columns'
                "
            >
            </DetailInfoGroup>
        </div>
        <MLS
            :readmore="listingGroups && listingGroups.length > 1"
            theme="classic"
            :provided="positionProvided === PROVIDED_POSITION_KEY.under && 'template1'"
            @readMore="onReadMore"
            ref="mls"
        ></MLS>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore } from '@/store';
import util from '@/common/util';
import DetailInfoHeader from './detail-info-header/index';
import DetailInfoGroup from '../detail-info-group.vue';
import MLS from '../mls.vue';
import Provided from '../provided';
import { PROVIDED_POSITION_KEY } from '@/common/mls';

export default {
    emits: ['readMore'],
    components: {
        DetailInfoHeader,
        DetailInfoGroup,
        MLS,
        Provided
    },
    inject: ['readMore'],
    props: ['positionProvided'],
    data: function() {
        return {
            PROVIDED_POSITION_KEY,
            agentInfo: {}
        };
    },
    methods: {
        onReadMore() {
            this.readMore(opened => {
                let oldTop = util.winScrollTop();
                this.$nextTick(() => {
                    if (opened) {
                        util.winScrollTop(oldTop);
                    } else {
                        let top = this.$refs.mls.$el.offsetTop;
                        util.winScrollTop(top + window.innerHeight / 2);
                    }
                });
                setTimeout(() => {
                    this.$emit('readMore');
                }, 0);
            });
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        ...mapState({
            'listingDetail': store => store.listingDetail,
            'shares': store => store.shares,
            'triggerReadMore': store => store.triggerReadMore,
            'openReadMore': store => store.openReadMore,
            'listingGroups': store => store.listingDetail.listingGroups
        }),
        info() {
            return this.listingDetail.info || {};
        },
        daysOnSite() {
            return this.listingDetail.daysOnSite || 10;
        },

        showShare() {
            return (
                this.listingDetail.facebookHref ||
                this.listingDetail.twitterHref ||
                this.listingDetail.linkedinHref
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-detail-info.classic {
    .detail-info-container {
        .detail-info {
            overflow: hidden;
            position: relative;
            .listingdetail-share {
                display: none;
            }
            .detail-schedule {
                display: none;
            }
            .detail-info-group {
                .on-site {
                    display: none;
                }
            }
            .read-more {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                background: #fff;
                padding-top: 10px;
                @include color-theme();
                text-align: center;
                text-decoration: underline;
                cursor: pointer;
                font-size: 16px;
                ::before {
                    content: '';
                    display: block;
                    position: absolute;
                    bottom: 100%;
                    height: 20px;
                    background-image: linear-gradient(
                        to bottom,
                        rgba(255, 255, 255, 0),
                        #fff
                    );
                    width: 100%;
                }
                &.opened {
                    ::before {
                        display: none;
                    }
                }
            }
        }
        @include media-1280 {
            .detail-info {
                .no-margin-top-pre-next {
                    margin-top: 0;
                }
                .no-margin-top-pre-next {
                    margin-top: 0;
                }
            }
        }

        @include media-800 {
            .detail-info {
                margin-top: 15px;
                .listingdetail-share {
                    display: inline-block;
                    margin-bottom: 30px;
                }
                .detail-schedule {
                    display: block;
                }
                .detail-info-group {
                    padding: 0;
                }
            }
        }
    }
}
</style>
